export default class ApplicationDog {
    static fromData(data) {
        if (!data) {
            return;
        }

        const applicationDog = new ApplicationDog();
        applicationDog.id = data.id;
        applicationDog.name = data.name;
        applicationDog.chipNumber = data.chipNumber;
        applicationDog.gender = data.gender;
        applicationDog.breed = data.breed;
        applicationDog.breedSpecialization = data.breedSpecialization;
        applicationDog.breedingBookNumber = data.breedingBookNumber;
        applicationDog.dateOfBirth = data.dateOfBirth;
        applicationDog.dog = data.dog;
        applicationDog.ownerRegistrationMemberIds = data.ownerRegistrationMemberIds;
        applicationDog.handlerRegistrationMemberIds = data.handlerRegistrationMemberIds;

        applicationDog.open = false;
        return applicationDog;
    }

    serialize() {
        const applicationDog = Object.assign({}, this);
        applicationDog.breed = applicationDog.breed ? applicationDog.breed.key : null;
        applicationDog.breedSpecialization = applicationDog.breedSpecialization ? applicationDog.breedSpecialization.key : null;
        return applicationDog;
    }
}
